import { debugConfig } from "./debug-config";

/**
 * Utility class for tracking throughput at different stages of the audio pipeline
 */
export class ThroughputTracker {
  private label: string;
  private totalVolume: number = 0;
  private startTime: number | null = null;
  private lastLogTime: number = 0;
  private readonly logIntervalMs: number = 2000; // 2 seconds

  constructor(label: string) {
    this.label = label;
  }

  /**
   * Track a receive event with a volume
   * @param volume - The volume/frame count to track
   */
  receive(volume: number): void {
    if (!debugConfig.isStreamMonitoringEnabled()) {
      return;
    }
    this.totalVolume += volume;

    // Set start time on first receive
    if (this.startTime === null) {
      this.startTime = Date.now();
      this.lastLogTime = this.startTime;
    }

    const now = Date.now();
    const timeSinceLastLog = now - this.lastLogTime;

    // Log throughput every 2 seconds (only if monitoring is enabled)
    if (timeSinceLastLog >= this.logIntervalMs) {
      let throughputFps = 0;
      if (this.startTime !== null && this.totalVolume > 0) {
        const elapsedTimeSeconds = (now - this.startTime) / 1000;
        throughputFps = this.totalVolume / elapsedTimeSeconds;
      }
      console.log(
        `[${this.label}] throughput:`,
        throughputFps.toFixed(2),
        "fps",
      );
      this.lastLogTime = now;
    }
  }

  /**
   * Reset throughput tracking
   */
  reset(): void {
    this.totalVolume = 0;
    this.startTime = null;
    this.lastLogTime = 0;
  }
}
